import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Portal from 'utils/portal/Portal';
import Header from '../../header/Header';
import { areas } from 'constants/areas';
import { withAreaGetter } from 'providers/AreasConsumers';
import PartnerTypesContainer from './PartnerTypesContainer';
import PermissionCheck from 'components/common/PermissionCheck';
import { ADMIN_PARTNER_TYPES_READ } from 'constants/rightsCodes';

const Route = ({ getElemByAreaKey }) => {
  return (
    <Fragment>
      <Portal container={getElemByAreaKey(areas.header)}>
        <Header />
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_PARTNER_TYPES_READ}>
        <PartnerTypesContainer />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func
};

export default withAreaGetter(Route);
